<template>
  <div>
    <wc-section-title title='Field Crews'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'field-crews-base',
  computed: {
    menu () {
      return [
        {
          title: 'Fieldcrews Dashboard',
          icon: this.$store.state.icons.modules.fieldcrews.icon,
          route: { name: 'FieldcrewsDashboard' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Fieldcrews Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  }
}
</script>
